import Vue from 'vue'
import Auth from '../auth'
import Router from 'vue-router'
import Conflicts from '@/components/Conflicts'
import Login from '@/components/Login'

Vue.use(Router)

const router = new Router({
  routes: [
    {
      path: '/',
      name: 'Conflicts',
      component: Conflicts,
      meta: {
        auth: true
      }
    },
    {
      path: '/login',
      name: 'Login',
      component: Login
    }
  ]
})

router.beforeEach((to, from, next) => {
  const authRequired = to.matched.some((route) => route.meta.auth)
  const authed = Auth.user.authenticated
  if (authRequired && !authed) {
    next('/login')
  } else {
    next()
  }
})
export default router



// WEBPACK FOOTER //
// ./src/router/index.js